import { createSelector } from 'reselect';

const getUser      =   (state)  => state.authentication.user;
const getDate       =   (state, props) => props.date;
const getEvents     = (state) => state.event.entities;

const getScheduleByDay = createSelector(
    [ getUser, getDate, getEvents ],
    (user, date, events) => {

        let allEvents = events.allIds.map((eventId) => events.byId[eventId]);

        return allEvents.filter((event) => {

            let eventDate = new Date(event.startDateUtc.replace(' ', 'T'));

            if (eventDate.getUTCDate() == date.getUTCDate() && eventDate.getUTCFullYear() == date.getUTCFullYear() && eventDate.getUTCMonth() == date.getUTCMonth()) {
                return true;
            }
            return false;
        });

        
    }
);

export default getScheduleByDay;
